import React, { FC } from 'react';
import * as S from './styled';
import heart from '../../../../img/heart_only.png';
import arrow from '../../../../img/arrow.png';

interface Props {
	monthsCount: number;
}

export const RecommendedBlock: FC<Props> = props => {
	const { monthsCount } = props;
	const monthsText = monthsCount === 1 ? 'Month' : 'Months';
	const monthsContValue = monthsCount > 0 ? monthsCount : 1;
	return (
		<>
			<S.Container>
				<S.Icon src={heart} width={38} alt='heart' />
				<S.Text>
					<S.Title>
						{monthsContValue} {monthsText} plan recommended
					</S.Title>
					<S.Description>
						According to research, a healthy weight loss rate per week is no more than 1% of your
						body weight and no more than 1.3 kg / week
					</S.Description>
				</S.Text>
			</S.Container>
			<S.Choose>
				Choose your plan
				<S.Arrow src={arrow} width={21} alt='arrow' />
			</S.Choose>
		</>
	);
};
